import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDGQ0CWKJq8FExXXTzv18o2iKxNeqp6Etk",
  authDomain: "survival-crafting-app.firebaseapp.com",
  projectId: "survival-crafting-app",
  storageBucket: "survival-crafting-app.firebasestorage.app",
  messagingSenderId: "485490894406",
  appId: "1:485490894406:web:f8eea5ba900b9a30180c47"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
